export default __webpack_public_path__ + "static/media/edlogo.e47b2578.png";